import SourceFlowText from "@sourceflow-uk/sourceflowtext"
import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import {
    Container,
    Row,
    Col,
} from "reactstrap";
import styles from './styles.module.scss';
import Link from 'next/link';

export default function SimpleImageWithText({
    global,
    pathPrefix,
    customClass = "",
    content1,
    imageAltText,
    imageUrl,
    backgroundColor,
}) {
    return (
        <>
            <section className={`${styles.root} ${customClass}`} >
                <Container>
                    <Row>
                        <Col lg={6}>
                            <div className="imageWrapper rounded-3 shadow overflow-hidden">
                                <SourceFlowImage
                                    src={imageUrl ? `${imageUrl}` : "/site-assets/images/image-placeholder.webp"}
                                    size="800x800"
                                    alt={imageAltText}
                                    className="card-img rounded-0"
                                    width="100%"
                                    height="100%"
                                />
                            </div>
                        </Col>
                        <Col lg={6}>
                            <div className={`content-wrapper p-3 p-md-5 rounded-3  secondaryBg overflow-hidden shadow`} style={{backgroundColor: backgroundColor}}>
                                <SourceFlowText global={global} path={`${pathPrefix}.content1`} type="html">
                                    {content1}
                                </SourceFlowText>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}